function price(n, c) {
  var fr = $('html').attr('lang') == 'fr',
  c = c == undefined ? 2 : c,
  d = fr ? ',' : '.',
  t = ' ', 
  s = n < 0 ? "-" : "", 
  i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
  j = (j = i.length) > 3 ? j % 3 : 0,
  newp = s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
  newp = fr ? (newp + '$') : ('$' + newp);

  return newp;
}